// reducers/officePrice.reducer.js
import { officePriceConstants as C } from '../actions/constants';

const init = {
    map: {},        // { [productId]: { price, pricePerMeter } }
    loading: false,
    saving: false,
    error: null,
    lastTouchedId: null,
};

export default function officePrice(state = init, action) {
    switch (action.type) {
        case C.MAP_REQUEST:
            return { ...state, loading: true, error: null };
        case C.MAP_SUCCESS:
            return { ...state, loading: false, map: action.payload || {} };
        case C.MAP_FAILURE:
            return { ...state, loading: false, error: action.payload || 'Ошибка' };

        case C.SET_REQUEST:
        case C.REMOVE_REQUEST:
            return { ...state, saving: true, error: null, lastTouchedId: action.meta?.productId || null };
        case C.SET_SUCCESS:
        case C.REMOVE_SUCCESS:
            return { ...state, saving: false };
        case C.SET_FAILURE:
        case C.REMOVE_FAILURE:
            return { ...state, saving: false, error: action.payload || 'Ошибка', lastTouchedId: action.meta?.productId || null };

        default:
            return state;
    }
}
